export const GRUPO_LABELS = {
  BEZERRA: "Bezerra",
  NOVILHA: "Novilha",
  PRE_PARTO: "Pré-parto",
  LACTANTE_PRIMIPARA: "Primípara (lactante)",
  LACTANTE_MULTIPARA: "Multípara (lactante)",
  SECA: "Vaca seca",
  BEZERRO: "Bezerro",
  NOVILHO: "Novilho",
  TOURO: "Touro (reprodutor)",
};

export const GRUPO_OPTIONS = Object.entries(GRUPO_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const ROLE_LABELS = {
  admin: "Administrador",
  veterinario: "Veterinário",
  tecnico: "Técnico",
  monitor: "Monitor",
};

export const ROLE_OPTIONS = Object.entries(ROLE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const STATUS_LABELS = {
  ATIVO: "Ativo",
  VENDIDO: "Vendido",
  MORTO: "Morto",
  DESCARTADO: "Descartado",
};

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    // Datas "YYYY-MM-DD" ou "YYYY-MM-DDT..." são formatadas manualmente
    // para evitar o deslocamento de fuso (new Date("2026-02-15") vira 14/02 no BRT).
    if (typeof iso === "string") {
      const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    }
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
    return d.toLocaleDateString("pt-BR");
  } catch {
    return iso;
  }
}

// Interpreta "YYYY-MM-DD" como data local (sem shift de fuso).
// Retorna um Date válido no fuso do navegador ou null.
export function parseLocalDate(iso) {
  if (!iso) return null;
  const s = typeof iso === "string" ? iso : String(iso);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}
